<template>
  <main>
    <form
      class="form-entrar"
      @submit.prevent="logar"
    >
      <nav
        class="btn-voltar"
        aria-label="Navegação de retorno"
      >
        <router-link to="/login">Voltar</router-link>
      </nav>

      <h1>Entrar no GEX</h1>

      <div>
        <label for="login">
          Login GEX:
          <span
            title="Entre com o número do CPF ou e-mail cadastrado no GEX."
            style="
              cursor: help;
              margin-left: 4px;
              color: #713cba;
              font-size: 0.9em;
            "
            >(?)</span
          >
        </label>
        <input
          id="login"
          class="input-login"
          type="text"
          v-model="email"
          required
          autofocus
        />
      </div>

      <div>
        <label for="senha">Senha GEX:</label>
        <input
          id="senha"
          class="input-login"
          type="password"
          v-model="senha"
          required
        />
      </div>

      <div id="div-links">
        <router-link to="/cadastro">Não tenho cadastro</router-link>
        <router-link :to="{ name: 'recuperar-senha' }">
          Esqueceu a senha? Clique aqui para recuperá-la.
        </router-link>
      </div>

      <button
        class="submit-login"
        type="submit"
        :disabled="loading"
      >
        <div v-if="loading">
          <carregamento :tipo-carregamento="'input'" />
        </div>
        <div v-else>Entrar</div>
      </button>

      <div
        id="div-validacao"
        v-if="mensagemDeErro"
        aria-live="assertive"
        role="alert"
      >
        {{ mensagemDeErro }}
      </div>
    </form>
  </main>
</template>

<script setup>
import { autenticacaoLoginGex } from "@/service/authService";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import Carregamento from "@/components/common/Carregamento.vue";

const email = ref("");
const senha = ref("");
const loading = ref(false);
const auth = useAuthStore();
const router = useRouter();
const mensagemDeErro = ref("");

function sucessoNoLogin(novoAccess, novoRefresh) {
  auth.atualizarSessao(novoAccess, novoRefresh);
}

async function logar() {
  // O event.preventDefault() agora é tratado nativamente pelo '.prevent' no template
  window.localStorage.removeItem("auth_token");
  window.localStorage.removeItem("autenticadoSigaa");
  loading.value = true;
  mensagemDeErro.value = "";

  try {
    const response = await autenticacaoLoginGex(email.value, senha.value);
    if (response && response.status === 200) {
      const { token, refreshToken } = response.data;
      if (token !== null) {
        sucessoNoLogin(token, refreshToken);
        router.push("/");
      }
    }
  } catch (error) {
    console.error("Erro ao realizar login GEX:", error);
    const status = error?.status || error?.response?.status;
    let rawMsg =
      error?.data?.message ||
      error?.response?.data?.message ||
      error?.data?.details ||
      error?.response?.data?.details ||
      "";

    if (rawMsg.includes('"')) {
      const matchAspas = rawMsg.match(/"([^"]+)"/);
      if (matchAspas && matchAspas[1]) {
        rawMsg = matchAspas[1];
      }
    }
    rawMsg = rawMsg.replace(/^\d{3}\s+[A-Z_\s]+:?\s*/i, "").trim();

    if (status === 401 || status === 400) {
      mensagemDeErro.value =
        rawMsg || "Credenciais inválidas: usuário ou senha incorretos!";
    } else {
      mensagemDeErro.value =
        rawMsg || "Ocorreu um erro ao tentar realizar o login. Tente novamente mais tarde.";
    }
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter", Avenir, Helvetica, Arial, sans-serif;
}

.login-layout {
  background: linear-gradient(90deg, #362065 0%, #5e2ea0 100%);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.form-entrar {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 420px;
  animation: fadeIn 0.4s ease-in-out;
}

/* Título */
.form-entrar h1 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  color: #4a1d8a; /* Roxo escurecido para contraste de acessibilidade AAA */
  text-align: center;
}

/* Botão voltar - Correção dos seletores quebrados */
.btn-voltar a {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.6rem;
  background: #713cba;
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  color: #fff;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-voltar a::before {
  content: "←";
  font-size: 0.9rem;
}

.btn-voltar a:hover {
  background: #5e2ea0;
}

.btn-voltar a:active {
  background: #4a1d8a;
}

.form-entrar label {
  font-size: 0.95rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 0.3rem;
  display: block;
}

.input-login {
  width: 100%;
  padding: 0.9rem 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 400;
  color: #000;
  outline: none;
  transition:
    border 0.3s ease,
    box-shadow 0.3s ease;
}

.input-login:focus {
  border-color: #713cba;
  box-shadow: 0 0 0 3px rgba(113, 60, 186, 0.2);
}

/* Botão Entrar */
.submit-login {
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff;
  background: #713cba;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-login:hover {
  background: #5e2ea0;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(94, 46, 160, 0.3);
}

.submit-login:disabled {
  background-color: #a0aec0;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Links extras - Contraste aprimorado para #4a1d8a */
#div-links {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-top: 0.5rem;
}

#div-links a {
  font-size: 0.9rem;
  font-weight: 700;
  color: #4a1d8a;
  text-decoration: none;
  transition: color 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

#div-links a:hover {
  color: #713cba;
  text-decoration: underline;
}

#div-validacao {
  border: none;
  color: #e11d48;
  font-size: 0.85rem;
  text-align: center;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 500px) {
  .form-entrar {
    padding: 2rem 1.2rem;
    max-width: 100%;
  }

  .form-entrar h1 {
    font-size: 1.5rem;
  }

  .submit-login {
    padding: 0.85rem;
    font-size: 0.95rem;
  }

  #div-links {
    gap: 0.5rem;
  }
}
</style>
